import React, { useEffect, createElement, Component } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { App } from './App';
import { initMetaPixel, track } from './components/tracking/metaPixel';
// Meta Pixel ID
const PIXEL_ID = '677795406465841';
// Microsoft Clarity ID
const CLARITY_ID = 'themvs5171';
// Component to handle route change tracking
function RouteChangeTracker() {
  const location = useLocation();
  useEffect(() => {
    // Track PageView on route change
    track('PageView');
  }, [location]);
  return null;
}
export function AppRouter() {
  useEffect(() => {
    // Initialize Meta Pixel with the exact implementation from Meta
    initMetaPixel(PIXEL_ID);
    // Initialize Microsoft Clarity using the script approach
    if (typeof window !== 'undefined') {
      ;
      (function (c, l, a, r, i, t, y) {
        c[a] = c[a] || function () {
          ;
          (c[a].q = c[a].q || []).push(arguments);
        };
        t = l.createElement(r);
        t.async = 1;
        t.src = 'https://www.clarity.ms/tag/' + i;
        y = l.getElementsByTagName(r)[0];
        y.parentNode.insertBefore(t, y);
      })(window, document, 'clarity', 'script', CLARITY_ID);
    }
  }, []);
  return <BrowserRouter data-id="element-31">
      <RouteChangeTracker data-id="element-32" />
      <Routes data-id="element-33">
        <Route path="/" element={<App data-id="element-35" />} data-id="element-34" />
      </Routes>
    </BrowserRouter>;
}